module.exports = "\n<div *ngIf=\"after\">\nThe room is not opened yet. It will be in {{startsAt}}.\n</div>\n<div *ngIf=\"before\">\n  The room has closed. It was opened at {{startsAt}}.\n  </div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/not-ready-room.component.html
// module id = ../../../../../src/app/wb/not-ready-room.component.html
// module chunks = main